import React, { useEffect, useState } from 'react';
import { Handle, Position } from 'reactflow';
import { useDispatch, useSelector } from 'react-redux';
import AddToList from '../../../../../assets/icons/flows/add_to_list.svg';
import Edit from '../../../../../assets/icons/flows/edit.svg';
import Alert from '../../../../../assets/icons/flows/alert.svg';
import Delete from '../../../../../assets/icons/flows/delete.svg';
import Divider from '../../../../../assets/icons/divider.svg';
import {
  clearActiveSettings,
  deleteSettings,
  selectConfigsList,
  selectErrors,
  selectFlowStatus,
  setActiveSettings,
} from '../../../../../store/reducers/flows';

import { handle, handleInput } from '../../../../../utils/flows';
import Tooltip from '../../../../../components/ui/Tooltip';

import styles from '../EmailNode/EmailNode.module.scss';

const AddToListNode = ({ ...props }) => {
  const dispatch = useDispatch();

  const [data, setData] = useState();
  const [completed, setCompleted] = useState(false);
  const [onNodeHover, setOnNodeHover] = useState(false);

  const configList = useSelector(selectConfigsList);
  const errors = useSelector(selectErrors);
  const status = useSelector(selectFlowStatus);

  const filteredErrors = () =>
    errors.length && errors.filter((elem) => elem.node_id === props.id);

  useEffect(() => {
    if (configList.length) {
      const index = configList
        .map((object) => object.node_id)
        .indexOf(props.id);
      if (index >= 0) {
        setData(configList[index]);
      }
    }
  }, [configList, props.id]);

  useEffect(() => {
    if (data && data?.list_name && data.name) {
      setCompleted(true);
    } else {
      setCompleted(false);
    }
  }, [data]);

  return (
    <>
      <div
        className={`
        ${styles.wrapper}
        ${styles.wrapper_list}
        ${data && data?.list_name ? styles.size120 : ''}
        ${status === 'running' || status === 'scheduled' || status === 'stopped' ? 'cursor-pointer' : ''}
        d-flex
        flex-column
        justify-content-center
        `}
        role="presentation"
        onMouseEnter={() => setOnNodeHover(true)}
        onMouseLeave={() => setOnNodeHover(false)}
        onClick={() => {
          if (
            status === 'running' ||
            status === 'scheduled' ||
            status === 'stopped'
          ) {
            dispatch(
              setActiveSettings({ type: 'addToListNode', node_id: props.id })
            );
          }
        }}
      >
        <div className="d-flex align-items-center justify-content-between gap-2 w-100">
          <div
            className={`${styles.title_size} d-flex align-items-center gap-1`}
          >
            {status !== 'running' &&
            status !== 'stopped' &&
            status !== 'scheduled' ? (
              <>
                {!completed || filteredErrors().length ? (
                  <>
                    <div
                      className={styles.alert}
                      data-for={`${props.id}_error`}
                      data-tip
                    >
                      <Alert />
                    </div>
                    {filteredErrors().length ? (
                      <Tooltip
                        id={`${props.id}_error`}
                        info={`${filteredErrors()[0].type}: ${filteredErrors()[0].detail}`}
                      />
                    ) : null}
                  </>
                ) : null}
                <div
                  className={onNodeHover ? styles.delete : styles.delete_hide}
                >
                  <Delete
                    onClick={() => {
                      props.data.onRemove(props.id);
                      dispatch(deleteSettings(props.id));
                      dispatch(clearActiveSettings());
                    }}
                  />
                </div>
              </>
            ) : null}
            <AddToList />
            <div className={`${styles.description} text-truncate`}>
              {(data && data?.name) || 'Add to list'}
            </div>
          </div>
          <div
            className="cursor-pointer"
            role="presentation"
            onClick={(e) => {
              e.preventDefault();
              dispatch(
                setActiveSettings({ type: 'addToListNode', node_id: props.id })
              );
            }}
          >
            <Edit />
          </div>
        </div>
        {data && data?.list_name ? (
          <div>
            <div className={`${styles.divider} d-flex`}>
              <Divider />
            </div>
            <div className={`${styles.info} d-flex`}>
              <div
                className={`${styles.info_col} d-flex flex-column gap-1 w-100`}
              >
                <div>List name:</div>
                <div className={`${styles.list} text-truncate`}>
                  {data.list_name}
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
      <Handle
        type="target"
        position={Position.Left}
        style={{ ...handleInput, left: '-10px' }}
      />
      <Handle
        type="source"
        position={Position.Right}
        style={{ ...handle, right: '-16px' }}
        id="addToListNode_output"
      />
    </>
  );
};

export default AddToListNode;
